import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../actions';

function ViewDocument({ url, data }) {
  const setModal = useContext(ModalContext);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              {!_.isEmpty(url) && (
                <div className="col-12 d-flex justify-content-center">
                  <iframe
                    style={{ width: '100%', height: 600, border: 'none', display: 'flex', justifyContent: 'center' }}
                    title="View Image/Document"
                    src={url}
                  />
                </div>
              )}
              {!_.isEmpty(data) && 
                (data.map((item) => { return (
                  <div className="col-12 d-flex justify-content-center mx-3">
                    {item.fileType === 'application/pdf' || _.isEmpty(item.fileType) ? (
                      <iframe
                        style={{ width: '100%', height: 600, border: 'none', display: 'flex', justifyContent: 'center' }}
                        title="View Image/Document"
                        src={item.url}
                      />
                    ) : (
                      <img
                        className="h-100 pb-3"
                        title="View Image/Document"
                        alt={ImagePlaceholder}
                        src={item.url}
                      />
                    )}
                  </div>
                )})
              )}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
ViewDocument.defaultProps = {
  url: '',
  data: [],
};
ViewDocument.propTypes = {
  url: PropTypes.string,
  data:PropTypes.instanceOf(Array),
  // fileType: PropTypes.string,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewDocument);
